import { apiService } from "../store";
import { groupLoaded } from "./selects";
import { fetchClient, fetchClients } from "./client";
import { scheduleTrainer } from "./trainer";
import moment from "moment";

const adminsLoaded = (admins) => {
  return {
    type: "ADMINS_LOADED",
    payload: admins,
  };
};
const adminsRequested = () => {
  return {
    type: "ADMINS_REQUESTED",
  };
};

const basePriceRequested = (cost) => {
    return {
        type: 'BASE_PRICE_REQUESTED',
        payload: cost
    }
}

const basePriceLoading = (loading) => {
    return {
        type: 'BASE_PRICE_LOADING',
        payload: loading
    }
}

const basePriceUpdating = updating => {
    return {
        type: 'BASE_PRICE_UPDATING',
        payload: updating
    }
}
// TRAINER BASE PRICE START
const baseTrainerPriceRequested = (cost) => {
    return {
        type: 'TRAINER_BASE_PRICE_REQUESTED',
        payload: cost
    }
}

const baseTrainerPriceLoading = (loading) => {
    return {
        type: 'TRAINER_BASE_PRICE_LOADING',
        payload: loading
    }
}

const baseTrainerPriceUpdating = updating => {
    return {
        type: 'TRAINER_BASE_PRICE_UPDATING',
        payload: updating
    }
}


const messageError = (error) => {
  return {
    type: "MESSAGE_ERROR",
    payload: error,
  };
};

const kanbanLoaded = (newKanban) => {
  return {
    type: "KANBAN_LOADED",
    payload: newKanban,
  };
};
const kanbanLoadedColumns = (columns) => {
  return {
    type: "KANBAN_COLUMNS",
    payload: columns,
  };
};
const kanbanError = (error) => {
  return {
    type: "KANBAN_ERROR",
    payload: error,
  };
};
const kanbanDragged = (result) => {
  return {
    type: "KANBAN_DRAGGED",
    payload: result,
  };
};
const kanbanRequested = () => {
  return {
    type: "KANBAN_REQUESTED",
  };
};
const calendarRequested = () => {
  return {
    type: "CALENDAR_REQUESTED",
  };
};
const calendarLoaded = (newCalendar) => {
  return {
    type: "CALENDAR_LOADED",
    payload: newCalendar,
  };
};

const calendarSelectedEvents = (newEventId) => {
  return {
    type: "CALENDAR_SELECTED_EVENT",
    payload: newEventId,
  };
};
const childrenToggle = (childrenId) => {
  return {
    type: "CHILDREN_TOGGLE",
    payload: childrenId,
  };
};
const setCalendarFilter = (payload) => {
  return {
    type: "SET_CALENDAR_FILTER",
    payload,
  };
};
const stateScheduleData = (payload) => {
  return {
    type: "STATE_SCHEDULE_DATA",
    payload,
  };
};

const requestTraining = (payload) => {
  return {
    type: "REQUEST_TRAINING",
    payload,
  };
};
const scheduleLoading = (bool) => {
  return {
    type: "SCHEDULE_LOADING",
    payload: bool,
  };
};

const scheduleCreate = (schedule, calendar) => (dispatch) => {
  apiService
    .createSchedule(schedule)
    .then(() => {
      dispatch(fetchCalendar(calendar));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

const scheduleRequest = (id) => (dispatch) => {
  dispatch(scheduleLoading(true));
  apiService
    .getSchedule(id)
    .then((data) => {
      dispatch(scheduleTrainer(data));
      dispatch(scheduleLoading(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

const scheduleRequestNoLoading = (id) => (dispatch) => {
  apiService
    .getSchedule(id)
    .then((data) => {
      dispatch(scheduleTrainer(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

const scheduleUpdate =
  (id, payload, refresh = true) =>
  (dispatch) => {
    apiService
      .updateSchedule(id, payload)
      .then(() => {
        if (refresh) {
          dispatch(loadTraining(id));
        }
      })
      .catch((err) => {
        dispatch(messageError(err.response.data.message));
      });
  };
const scheduleDelete = (id, calendar) => (dispatch) => {
  apiService
    .deleteSchedule(id)
    .then(() => {
      dispatch(fetchCalendar(calendar));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
const scheduleAppend = (append) => (dispatch) => {
  apiService
    .appendShedule(append)
    .then(() => {
      dispatch(fetchClient(append.client_id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchBaseInvoicePrice = () => (dispatch) => {
    dispatch(basePriceLoading(true))
    apiService
        .baseCostInvoiceRequest()
        .then((data) => {
            dispatch(basePriceRequested(data))
            dispatch(basePriceLoading(false))
        })
        .catch(() => {
            dispatch(basePriceLoading(false))
        })
}

export const fetchBaseInvoicePriceUpdate = (payload) => async (dispatch) => {
    dispatch(basePriceUpdating(true));
    try {
        await apiService.baseCostUpdateRequest(payload);
        dispatch(basePriceUpdating(false));
    } catch (error) {
        dispatch(basePriceUpdating(false));
        // Обработка ошибки, если необходимо
        console.error('An error occurred:', error);
    }
}
export const fetchTrainerBasePrice = () => (dispatch) => {
    dispatch(baseTrainerPriceLoading(true))
    apiService
        .baseCostTrainerRequest()
        .then((data) => {
            dispatch(baseTrainerPriceRequested(data))
            dispatch(baseTrainerPriceLoading(false))
        })
        .catch(() => {
            dispatch(baseTrainerPriceLoading(false))
        })
}

export const fetchTrainerBasePriceUpdate = (payload) => async (dispatch) => {
    dispatch(baseTrainerPriceUpdating(true));
    try {
        await apiService.baseCostTrainerUpdateRequest(payload);
        dispatch(baseTrainerPriceUpdating(false));
    } catch (error) {
        dispatch(baseTrainerPriceUpdating(false));
        // Обработка ошибки, если необходимо
        console.error('An error occurred:', error);
    }
}


const periodGroupsSchedule = (schedule, calendar) => (dispatch) => {
  apiService
    .groupsSchedulePeriod(schedule)
    .then(() => {
      dispatch(fetchCalendar(calendar));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

/*const changeCalendarFilter = (calendar, payload) => dispatch => {
  dispatch(setCalendarFilter(payload));
};*/

const loadTraining = (id) => (dispatch) => {
  apiService.getChildrenRequest(id).then((data) => {
    /*data.training-trainer.map(({ child }) => {
      child.name = `${child.first_name} ${child.last_name}`;
    });*/
    dispatch(calendarSelectedEvents(data));
  });
};
const updateStatusChildTraining = (id, schedule_id, payload) => (dispatch) => {
  apiService.updateStateChildrenTraining(id, payload).then(() => {
    dispatch(loadTraining(schedule_id));
  });
};

const trainingRequest = (id) => (dispatch) => {
  apiService.getTraining(id).then((data) => {
    dispatch(requestTraining(data));
  });
};

const createHistoryTraining = (required, payload) => (dispatch) => {
  apiService
    .createHistory(required, payload)
    .then(() => {
      dispatch(loadTraining(payload.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

const fetchCalendar = (calendar) => (dispatch) => {
  dispatch(calendarRequested());
  return apiService.getCalendarRequest(calendar.filter).then((data) => {
    dispatch(calendarLoaded(data));
  });
};
const fetchCalendarToday = () => (dispatch) => {
  const calendar = {
    startDay: moment().startOf("month").format("YYYY-MM-DD"),
    endDay: moment().endOf("month").format("YYYY-MM-DD"),
  };
  return apiService.getCalendarRequest(calendar).then((data) => {
    dispatch(calendarLoaded(data));
  });
};

const calendarDraggedDay = (id, start, calendar) => (dispatch) => {
  const training = calendar.calendar.find((el) => el.id === id);
  const newStart = moment(start)
    .subtract(2, "hours")
    .format("YYYY-MM-DD HH:mm:ss");
  const payload = {
    start: newStart,
    duration: training.duration,
    filial_id: training?.filial?.id,
    group_id: training?.group.id,
    trainer_id: training?.trainer.id,
    state_schedule_id: 1,
  };
  apiService
    .updateSchedule(id, payload)
    .then(() => {
      return apiService.getCalendarRequest(calendar.filter).then((data) => {
        dispatch(calendarLoaded(data));
      });
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

const stateSchedule = () => (dispatch) => {
  apiService
    .scheduleState()
    .then((data) => {
      dispatch(stateScheduleData(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchKanban = () => (dispatch) => {
  dispatch(kanbanRequested());
  apiService
    .getKanbanRequests()
    .then((data) => {
      const clients = data.map((item) => ({
        ...item,
        id: `task-${item.id}`,
        client_id: item.id,
        contact_name: `${item.last_name} ${item.first_name} ${item.middle_name}`,
      }));
      const untreated = clients.filter((task) => task.status_id === 2);
      const processed = clients.filter((task) => task.status_id === 3);
      const training = clients.filter((task) => task.status_id === 4);
      const column = {
        columns: {
          2: {
            id: "2",
            title: "Необработанные",
            taskIds: untreated.map((el) => el.id),
          },
          3: {
            id: "3",
            title: "В Обработке",
            taskIds: processed.map((el) => el.id),
          },
          4: {
            id: "4",
            title: "Записан на пробное",
            taskIds: training.map((el) => el.id),
          },
          1: {
            id: "1",
            title: "Успех",
            taskIds: [],
          },
          5: {
            id: "5",
            title: "Отказ",
            taskIds: [],
          },
        },
      };
      dispatch(kanbanLoadedColumns(column));
      dispatch(kanbanLoaded(clients));
    })
    .catch((err) => dispatch(kanbanError(err)));
};

export const updateKanbanRequested = (client) => (dispatch) => {
  apiService
    .updateClient(client)
    .then(() => {
      dispatch(fetchKanban());
      dispatch(fetchClients());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchAdmins = () => (dispatch) => {
  dispatch(adminsRequested());
  apiService
    .getAdminsRequests()
    .then((data) => {
      const admins = data.map((item) => ({
        ...item,
        name: `${item.last_name} ${item.first_name} ${item.middle_name}`,
      }));
      dispatch(adminsLoaded(admins));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export {
  kanbanLoaded,
  calendarLoaded,
  kanbanRequested,
  kanbanDragged,
  kanbanError,
  calendarRequested,
  calendarSelectedEvents,
  childrenToggle,
  setCalendarFilter,
  fetchCalendar,
  scheduleCreate,
  groupLoaded,
  loadTraining,
  scheduleDelete,
  messageError,
  scheduleAppend,
  periodGroupsSchedule,
  updateStatusChildTraining,
  trainingRequest,
  scheduleUpdate,
  createHistoryTraining,
  scheduleRequest,
  scheduleRequestNoLoading,
  stateSchedule,
  calendarDraggedDay,
  fetchCalendarToday,
};
